import { useEffect, useMemo, useState } from 'react';

import { ThemePreference } from '../components/auth/login/store/types';
import { useAppSelector } from './react-redux';
import { getCurrentUserDefaults } from '../components/home/store/selectors';

const systemPreferenceIsDark = window.matchMedia('(prefers-color-scheme: dark)');

export const useSystemColourPreference = () => {
    const [systemColourPreference, setSystemColourPreference] = useState<Omit<ThemePreference, ThemePreference.SYSTEM>>(systemPreferenceIsDark.matches ? ThemePreference.DARK : ThemePreference.LIGHT);
    const { themePreference } = useAppSelector(getCurrentUserDefaults);

    useEffect(() => {
        const eventListener = (e: MediaQueryListEvent) => setSystemColourPreference(e.matches ? ThemePreference.DARK : ThemePreference.LIGHT);
        systemPreferenceIsDark.addEventListener('change', eventListener);
        return () => systemPreferenceIsDark.removeEventListener('change', eventListener);
    }, []);

    const shouldUseDarkTheme = useMemo(() => themePreference === ThemePreference.DARK || (themePreference === ThemePreference.SYSTEM && systemColourPreference === ThemePreference.DARK), [themePreference, systemColourPreference]);

    return shouldUseDarkTheme;
};
